import { type ReactNode, useState } from 'react';
import { Modal } from './modal';

/**
 * A small "ⓘ" affordance that opens a modal explaining a metric. Keeps dense
 * dashboard tiles uncluttered while still letting a curious user learn exactly
 * what a number means. `label` titles the modal; `children` is the explanation.
 */
export function InfoButton({
  label,
  children,
  className,
}: {
  label: string;
  children: ReactNode;
  className?: string;
}) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button
        type="button"
        aria-label={`What is ${label}?`}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          setOpen(true);
        }}
        className={`inline-flex h-4 w-4 flex-none items-center justify-center rounded-full border border-hairline text-[0.6rem] font-bold text-muted transition-colors hover:border-iris hover:text-iris ${className ?? ''}`}
      >
        i
      </button>
      {open && (
        <Modal open onClose={() => setOpen(false)} title={label}>
          <div className="space-y-2 text-sm leading-relaxed text-haze">{children}</div>
        </Modal>
      )}
    </>
  );
}
